import React from "react";

export const SelectedDateContext = React.createContext(null);

export const getDateString = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}